<template>
    <div class="deskManages-main">
        <HeaderMenus :menuTitle="$t('后厨')" :tabList="tabList" @clickCallback="switchTab" ref="headerMenus"></HeaderMenus>
        <div class="cont">
            <User v-if="$refs.headerMenus && $refs.headerMenus.activeValue === '0'"></User>
            <!--            <Setting v-if="$refs.headerMenus && $refs.headerMenus.activeValue === '1'"></Setting>-->
        </div>
    </div>
</template>
<script>
import HeaderMenus from "@/components/common/headerMenus";
import User from './user';
import Setting from './setting';
import { submitResEnum } from "@/logic/buildStore";

export default {
    components: {
        HeaderMenus,
        User,
        Setting,
    },
    data() {
        return {
            tabList: [
                {
                    key: '0',
                    value: this.$t('后厨人员管理'),
                },
                // {
                //     key: '1',
                //     value: '基础设置',
                // },
            ]
        }
    },
    watch: {
    },
    methods: {
        switchTab(i) {
        },
        onSubmit() {
            return submitResEnum.success
        }
    },
    mounted() {
        this.$forceUpdate()
    }
};
</script>

<style>
.operation-wrap {
    height: 124px;
    border-radius: 8px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 30px 30px;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    overflow: hidden;
    background: #909399;
    background-size: 100% 100%;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/buildstore/services/kitchen/index.vue